import { createStyles } from 'antd-style'

import { BasicProps } from '@eastcoal/common/types/component'

import { RouterLink } from '@eastcoal/router/components/Link'

const useStyles = createStyles(({ token }) => ({
  link: {
    fontSize: token.fontSizeSM
  }
}))

export const AuditLink = ({ className, style }: BasicProps) => {
  const { cx, styles } = useStyles()

  return (
    <RouterLink
      className={cx(styles.link, className)}
      style={style}
      to='/audit/list'
    >
      认证信息管理
    </RouterLink>
  )
}
